import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../../service/api.service';
import { UserdataService } from '../../service/userdata.service';
import { AccessService } from '../../service/access.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

	public loading: boolean = true;
	public user_role: string = 'user'; // 'user' or 'owner'
	public account_info: any = null;
	public favorite_communities: any[] = [];
	public managed_communities: any[] = [];

	constructor(
		public access: AccessService,
		public userdata: UserdataService,
		public api: ApiService,
		private router: Router
	) {}

	ngOnInit() {
		this.api.get_account_info().subscribe((info: any) => {
			this.account_info = info;
			this.user_role = (info && info.role === 'owner') ? 'owner' : 'user';

			if (this.user_role === 'owner') {
				this.load_managed_communities();
			} else {
				this.load_favorites();
			}
		}, (err) => {
			console.error('Failed to load account info', err);
			this.load_favorites();
		});
	}

	load_favorites() {
		const ids = this.userdata.favorites();
		if (!ids || ids.length === 0) {
			this.loading = false;
			return;
		}
		this.api.get_community_info(ids).subscribe((communities: any) => {
			this.favorite_communities = communities || [];
			this.loading = false;
		}, (err) => {
			console.error('Failed to load favorites', err);
			this.loading = false;
		});
	}

	load_managed_communities() {
		this.api.get_managed_communities().subscribe((communities: any) => {
			this.managed_communities = communities || [];
			this.loading = false;
		}, (err) => {
			console.error('Failed to load managed communities', err);
			this.loading = false;
		});
	}

	go_to_community(id) {
		this.router.navigate(['/community', id]);
	}
}
